<ion-spinner name="bubbles" *ngIf="!gotData"></ion-spinner>
<div *ngIf="kiln && gotData && notConnected" class="main-status not-connected">
  {{ 'KILN_STATUS.KILN_NOT_CONNECTED' | translate }}
</div>
<div *ngIf="kiln && gotData && !notConnected" class="main-status">  
  <p class="ion-text-wrap error-text" *ngIf="errorText || kiln.status && kiln.status.mode == 'Error' && gotData">
    {{(kiln.status && kiln.status.error && kiln.status.error.err_text) || errorText}}
  </p>
  <div *ngIf="alarm.active" class="alarm"
    [ngClass]="alarmFlashClass">
    {{alarm.translationKey ? (alarm.translationKey | translate) : alarm.text}}
  </div>
   <ion-list *ngIf="kiln.status || kiln.program">
      <ion-item-divider color="light-shade">{{ 'KILN_STATUS.CURRENT_CONTROLLER_SETTINGS' | translate }} <span *ngIf="updating"><ion-spinner name="bubbles" color='light'></ion-spinner></span></ion-item-divider>
     <ion-item *ngIf="kiln.program && kiln.program.name">
       <ion-label>{{ 'KILN_STATUS.PROGRAM_NAME' | translate }}</ion-label>
      <p>{{kiln.program.name}} {{((kiln.program.speed && kiln.program.speed !== 'na') && (kiln.program.name && !kiln.program.name.includes(kiln.program.speed) && !kiln.program.name.toLowerCase().includes('custom'))) ? kiln.program.speed : ''}}</p>
     </ion-item>

    <!--  <ion-item *ngIf="kiln.program && kiln.program.steps">
       <ion-label>Preheat </ion-label>
      <p>{{kiln.program.steps[0].hr}}:{{kiln.program.steps[0].mn.toString().padStart(2, '0')}}</p>
     </ion-item> -->

     <ion-item *ngIf="kiln.program && kiln.program.cone && kiln.program.speed">
       <ion-label>{{ 'KILN_STATUS.CONE' | translate }}</ion-label>
      <p>{{kiln.program.cone}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.program && kiln.program.cone && kiln.program.speed">
       <ion-label>{{ 'KILN_STATUS.SPEED' | translate }}</ion-label>
      <p>{{kiln.program.speed}}</p>
     </ion-item>

     <ion-item *ngIf="kiln && kiln.status && kiln.status.firing && (kiln.status.firing.start_hour || kiln.status.firing.start_min)">
       <ion-label>{{ 'KILN_STATUS.DELAY' | translate }}</ion-label>
      <p>{{getDelayStartTime(kiln)}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing && kiln.status.firing.step && kiln.status.firing.step.substring(0,4) == 'Hold'">
       <ion-label>{{ 'KILN_STATUS.HOLD_REMAINING' | translate }}</ion-label>
      <p>{{kiln.status.firing.hold_hour}}:{{(kiln.status.firing.hold_min.toString().length == 2) ? kiln.status.firing.hold_min : '0'+kiln.status.firing.hold_min}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.program && kiln.program.alarm_t">
       <ion-label>{{ 'KILN_STATUS.ALARM' | translate }}</ion-label>
      <p>{{kiln.program.alarm_t}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing">
       <ion-label>{{ 'KILN_STATUS.FIRING_TIME' | translate }}</ion-label>
      <p *ngIf="kiln.status.mode === 'Firing' || kiln.status.mode === 'Complete' || kiln.status.mode.includes('Error') || kiln.status.mode.includes('Fail')">{{kiln.status.firing.fire_hour}}:{{(kiln.status.firing.fire_min.toString().length == 2) ? kiln.status.firing.fire_min : '0' + kiln.status.firing.fire_min}}</p>
      <p *ngIf="kiln.status.mode !== 'Firing' && kiln.status.mode !== 'Complete' && !kiln.status.mode.includes('Error') && !kiln.status.mode.includes('Fail')">---</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing && kiln.status.mode == 'Firing'">
       <ion-label>{{ 'KILN_STATUS.ESTIMATED_TIME_REMAINING' | translate }}</ion-label>
      <p>{{kiln.status.firing.etr}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing && kiln.status.mode == 'Complete'">
       <ion-label>{{ 'KILN_STATUS.COST' | translate }}</ion-label>
      <p>{{kiln.status.firing.cost}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing && kiln.status.mode == 'Firing'">
       <ion-label>{{ 'KILN_STATUS.SET_POINT' | translate }}</ion-label>
      <p>{{kiln.status.firing && kiln.status.firing.set_pt}}°{{kiln.config.t_scale}}</p>
     </ion-item>

     <ion-item *ngIf="kiln.status && kiln.status.firing && kiln.status.mode == 'Firing'">
       <ion-label>{{ 'KILN_STATUS.SEGMENT' | translate }}</ion-label>
      <p>{{kiln.status.firing.step}}</p>
     </ion-item>
   </ion-list>
  <ion-grid *ngIf="kiln.program && kiln.program.steps">
     <ion-row class="header">
       <ion-col>{{ 'KILN_STATUS.SEGMENT_HEADER' | translate }}</ion-col>
       <ion-col>{{ 'KILN_STATUS.RAMP' | translate }}</ion-col>
       <ion-col>{{ 'KILN_STATUS.TEMP' | translate }}</ion-col>
       <ion-col>{{ 'KILN_STATUS.HOLD' | translate }}</ion-col>
     </ion-row>
     <ion-row *ngFor="let step of kiln.program.steps; index as i;">
       <ion-col>{{step.num}} </ion-col>
       <ion-col>{{step.rt}} </ion-col>
       <ion-col>{{step.t}} </ion-col>
       <ion-col>{{step.hr}}:{{step.mn.toString().padStart(2, '0')}} </ion-col>
     </ion-row>    
  </ion-grid>
</div>

<!-- Stop Button Section -->
<app-stop-firing-button 
  *ngIf="toggleAccess('stop') && !stoppingFiring && supportsStopFiringFirmware()"
  [kiln]="kiln"
  [gotData]="gotData"
  [notConnected]="notConnected"
  (firingStopped)="onFiringStopped()"
  (stopError)="onStopError($event)">
</app-stop-firing-button>

<div *ngIf="hasElevatedPermissions" class="raw-kiln-status">
  <ion-button (click)="viewRawKilnStatus()">{{ 'KILN_STATUS.VIEW_RAW_KILN_STATUS' | translate }}</ion-button>   
  <ion-button (click)="toggleFiringLogs()">{{showLogs ? ('KILN_STATUS.HIDE_FIRING_LOG' | translate) : ('KILN_STATUS.SHOW_FIRING_LOG' | translate)}}</ion-button>         
</div>
<ion-list *ngIf="kiln && kiln.external_id && showLogs">
  <app-kiln-firing-log [externalId]="kiln.external_id"
    [inAdminPage]="true"></app-kiln-firing-log>
</ion-list>